<template>
  <div class="footer-wrap">
    <div class="footer-top">
      <div class="footer-top-item">
        <div>友情链接</div>
        <div>
          <a href="http://nynct.fujian.gov.cn/" target="_blank">福建农业农村厅</a>
        </div>
        <div>
          <a href="http://www.fankjt.com/" target="_blank">福建农垦茶业有限公司</a>
        </div>
      </div>
      <div class="footer-top-item">
        <div>主办单位</div>
        <div>福建农业农村厅</div>
        <div>福建农垦茶业有限公司</div>
      </div>
      <div class="footer-top-item">
        <div>技术支持</div>
        <div>神州数码系统集成服务有限公司</div>
        <div>北京旗硕基业科技股份有限公司</div>
      </div>
    </div>
    <div class="footer-bottom">最佳浏览模式：1920*1080分辨率，网站保留所有权，未经许可不得复制、镜像</div>
  </div>
</template>

<script>
export default {
  name: "footer-nav"
};
</script>

<style lang="scss" scoped>
.footer-wrap {
  width: 100%;
  height: 250px;
  background: #414141;
  .footer-top {
    width: 1300px;
    height: 200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #f2eeee;
    .footer-top-item {
      text-align: center;
      flex: 1;
      width: 1300px;
      margin: 0 auto;
      div {
        width: 400px;
        height: 50px;
        line-height: 50px;
        // margin-top: 20px;
        text-align: center;
      }
      a {
        color: #fff;
        text-decoration: none;
      }
    }
  }
  .footer-bottom {
    background: #313131;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #bababa;
    text-align: center;
  }
}
</style>